import { GENERATED_DOC_PAGES } from './content.generated';
import type { Section } from './blocks';

export type DocsPage = {
  path: string;
  label: string;
  title: string;
  description: string;
  lead: string;
  // Last real content change, from the markdown frontmatter. Feeds sitemap lastmod.
  updated: string;
  sections: Section[];
};

// Authored as markdown in content/docs/ and compiled by scripts/build-content.mjs.
export const DOC_PAGES: Record<string, DocsPage> = Object.fromEntries(
  GENERATED_DOC_PAGES.map((page) => [page.path, page]),
);

export const DOC_LINKS = Object.values(DOC_PAGES).map(({ path, label, description }) => ({ path, label, description }));

export type Crumb = { name: string; path: string };

// Home → Documentation → page. Rendered as a visible trail on the page and mirrored
// in BreadcrumbList schema, so both sides must come from here.
export function docsBreadcrumb(page?: DocsPage): Crumb[] {
  const trail: Crumb[] = [{ name: 'Home', path: '/' }, { name: 'Documentation', path: '/guide' }];
  return page ? [...trail, { name: page.title, path: page.path }] : trail;
}
